import React from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { relocationGuide } from '../data/categories';

const RelocationPage = () => {
  return (
    <Container className="py-5">
      <h1 className="mb-4">{relocationGuide.title}</h1>
      <p className="lead mb-5">{relocationGuide.description}</p>

      <Row>
        {relocationGuide.sections.map(section => (
          <Col key={section.id} md={6} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>{section.title}</Card.Title>
                <Card.Text>{section.content}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-5">
        <h2 className="mb-4">Why Move to Jamaica?</h2>
        <Card>
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <strong>Tropical Climate</strong> - Enjoy warm weather year-round with average temperatures between 75-85°F (24-29°C).
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Beautiful Scenery</strong> - From pristine beaches to lush mountains, Jamaica offers stunning natural beauty.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Rich Culture</strong> - Experience Jamaica's vibrant music, art, food, and traditions.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Relaxed Lifestyle</strong> - Embrace a more laid-back pace of life compared to many Western countries.
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Friendly People</strong> - Jamaicans are known for their warmth and hospitality to newcomers.
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>

      <div className="mt-5">
        <h2 className="mb-4">Popular Areas for Expats</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Kingston</Card.Title>
                <Card.Text>
                  The capital city offers urban amenities, cultural attractions, and business opportunities. Popular neighborhoods include New Kingston, Beverly Hills, and Jack's Hill.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Montego Bay</Card.Title>
                <Card.Text>
                  A tourist hub with beautiful beaches, international schools, and a large expat community. Spring Farm, Reading, and Ironshore are popular residential areas.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>Ocho Rios & Port Antonio</Card.Title>
                <Card.Text>
                  These coastal towns offer a more relaxed lifestyle with natural beauty and smaller communities, perfect for those seeking tranquility.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="mt-5">
        <h2 className="mb-4">Important Resources</h2>
        <Card>
          <Card.Body>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <strong>Passport, Immigration & Citizenship Agency (PICA)</strong><br />
                25 Constant Spring Road, Kingston 10<br />
                Phone: +1 (876) 754-0800<br />
                Website: <a href="https://www.pica.gov.jm/" target="_blank" rel="noopener noreferrer">www.pica.gov.jm</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Ministry of Health</strong><br />
                10-16 Grenada Way, Kingston 5<br />
                Phone: +1 (876) 633-7433<br />
                Website: <a href="https://www.moh.gov.jm/" target="_blank" rel="noopener noreferrer">www.moh.gov.jm</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>Ministry of Education</strong><br />
                2 National Heroes Circle, Kingston<br />
                Phone: +1 (876) 922-1400<br />
                Website: <a href="https://moey.gov.jm/" target="_blank" rel="noopener noreferrer">moey.gov.jm</a>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default RelocationPage;
